import { render, staticRenderFns } from "./SchoolsMap.vue?vue&type=template&id=2064d6e2&"
import script from "./SchoolsMap.vue?vue&type=script&lang=js&"
export * from "./SchoolsMap.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports